import { EnumReportRestaurantSortField } from '../../../../constants/enum';
import { sortNumberFunction, sortStringFunction } from '../../../../utils/sort';

export const sortReportRestaurant = (table, sort, sortOrder) => {
  const { itemData, itemList } = table;
  const itemListData = itemList.map(itemId => itemData[itemId]);

  if (Object.keys(itemData).length === 0) { return; }

  switch (sort) {
    case EnumReportRestaurantSortField.RESTAURANT.id: {
      const nestedField = 'name';
      itemListData.sort(sortStringFunction(nestedField, sortOrder));
      break;
    }
    case EnumReportRestaurantSortField.QUANTITY_ORDER.id: {
      const nestedField = 'success_order.order_sum_total';
      itemListData.sort(sortNumberFunction(nestedField, sortOrder));
      break;
    }
    case EnumReportRestaurantSortField.TOTAL_AMOUNT_BEFORE_DISCOUNT.id: {
      const nestedField = 'success_order.include_commission_value_sum_total_detail.value';
      itemListData.sort(sortNumberFunction(nestedField, sortOrder));
      break;
    }
    case EnumReportRestaurantSortField.MERCHANT_DISCOUNT.id: {
      const nestedField = 'success_order.merchant_discount_amount.value';
      itemListData.sort(sortNumberFunction(nestedField, sortOrder));
      break;
    }
    case EnumReportRestaurantSortField.COMMISSION.id: {
      const nestedField = 'success_order.commission_fee.value';
      itemListData.sort(sortNumberFunction(nestedField, sortOrder));
      break;
    }
    case EnumReportRestaurantSortField.TOTAL_AMOUNT.id:  {
      const nestedField = 'success_order.value_sum_total_detail.value';
      itemListData.sort(sortNumberFunction(nestedField, sortOrder));
      break;
    }
    default:
      break;
  }

  // eslint-disable-next-line no-param-reassign
  table.itemList = itemListData.map(item => item.id);
};


// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportRestaurant/components/utils.js